import { createContext, useContext, useEffect, useState, useCallback } from "react";

const ThemeContext = createContext({ theme: "light", toggle: () => {}, setTheme: () => {} });
const STORAGE_KEY = "emailink-theme";

const applyTheme = (t) => {
  if (typeof document === "undefined") return;
  const el = document.documentElement;
  el.classList.remove("dark", "theme-light");
  el.classList.add(t === "dark" ? "dark" : "theme-light");
  el.style.colorScheme = t === "dark" ? "dark" : "light";
};

export const ThemeProvider = ({ children }) => {
  const [theme, setThemeState] = useState(() => {
    if (typeof window === "undefined") return "light";
    try {
      return localStorage.getItem(STORAGE_KEY) || "light";
    } catch (e) {
      return "light";
    }
  });

  useEffect(() => {
    applyTheme(theme);
    try {
      localStorage.setItem(STORAGE_KEY, theme);
    } catch (e) {
      /* ignore */
    }
  }, [theme]);

  const setTheme = useCallback((t) => setThemeState(t === "dark" ? "dark" : "light"), []);
  const toggle = useCallback(() => setThemeState((p) => (p === "dark" ? "light" : "dark")), []);

  return (
    <ThemeContext.Provider value={{ theme, toggle, setTheme }}>{children}</ThemeContext.Provider>
  );
};

export const useTheme = () => useContext(ThemeContext);
